import React, {InputHTMLAttributes} from 'react'
import {FieldValues, FieldErrors} from 'react-hook-form'
import {ErrorMessage} from '@hookform/error-message'
import {KTText} from '../KTText'

interface Props
 extends InputHTMLAttributes<HTMLInputElement> {
 label?: string
 type: string
 id?: string
 name: string
 className?: string
 wrapperClassName?: string
 listItemClassName?: string
 listItemActiveClassName?: string
 labelClassName?: string
 errorIconClassName?: string
 listLabelClassName?: string
 helperTextClass?: string
 containerClass?: string
 listWrapperClass?: string
 helperText?: string
 register?: FieldValues
 errors?: FieldErrors | undefined
 data: FieldValues
 OptionValueKey: string | number
 OptionLabelKey: string
}

const RadioButtonField = ({
 type,
 label,
 className,
 wrapperClassName,
 listItemClassName,
 listItemActiveClassName,
 listLabelClassName,
 id,
 name,
 data,
 value,
 register,
 required,
 listWrapperClass,
 OptionValueKey,
 OptionLabelKey,
 containerClass,
 labelClassName,
 autoFocus,
 onChange,
 onBlur,
 disabled = false,
 readOnly = false,
 autoComplete = 'off',
 errors,
 helperTextClass,
 helperText,
}: Props) => {
 return (
  <div className={`${wrapperClassName}`}>
   <div className={`${containerClass}`}>
    {label && (
     <label
      htmlFor={id}
      className={`input-label ${labelClassName}`}
     >
      {label}
      {required && (
       <span className='required-field'>*</span>
      )}
     </label>
    )}
    <div className={`${listWrapperClass} inline-block`}>
     {data &&
      data.length > 0 &&
      data.map(
       (
        item: Record<string, string | number>,
        key: number
       ) => (
        <label
         htmlFor={`${id}-${item[OptionValueKey] ?? item}`}
         className={`${listItemClassName} ${
          listItemActiveClassName &&
          (item[OptionValueKey] ?? item) === value &&
          listItemActiveClassName
         } flex items-center mr-4 mt-2`}
         key={key}
        >
         <input
          type={type}
          className={`w-[25px] h-[25px] ${className} ${
           errors?.[name] && 'border-[#CC293F]'
          }`}
          placeholder=' '
          defaultChecked={
           (item[OptionValueKey] ?? item) === value
          }
          onChange={onChange}
          onBlur={onBlur}
          readOnly={readOnly}
          disabled={disabled}
          id={`${id}-${item[OptionValueKey] ?? item}`}
          value={item[OptionValueKey] ?? item}
          autoComplete={autoComplete}
          autoFocus={autoFocus}
          {...register}
         />
         <div
          className={`${listLabelClassName} ml-4 text-base`}
         >
          {item[OptionLabelKey] ?? item}
         </div>
        </label>
       )
      )}
    </div>
   </div>
   {helperText && !errors?.[name] && (
    <KTText className={helperTextClass}>
     {helperText}
    </KTText>
   )}
   {errors && (
    <ErrorMessage
     errors={errors}
     name={name}
     render={({message}) => (
      <p className='error-msg error-cls'>{message}</p>
     )}
    />
   )}
  </div>
 )
}

export {RadioButtonField}
